














































import {defineComponent, PropType} from "@vue/composition-api";
import {useState} from "vuex-composition-helpers";
import {IPortalTopic} from "@/apps/PortalTimelineWidget/models/portal-timeline-widget-state";

export default defineComponent({
    name: "PortalAccordionItem",
    props: {
        isActive: {type: Boolean, default: false},
        topic: {type: Object as PropType<IPortalTopic>, required: true},
        isDisabled: {type: Boolean, default: false},
        index: {type: Number}
    },
    setup: (props, { emit }) => {
        const { labels, currentlyOpenTopic } = useState(['labels', 'currentlyOpenTopic']);

        const resolveUrl = (url: string): string => {
            if (!url) {
                return '';
            }
            return url.startsWith('http')
                ? url
                : `${window.location.origin}${url}`;
        };

        const handleAccordionTitleClick = (topic: IPortalTopic, index: number, isActive: boolean) => {
            trackAccordionEvent(topic, isActive);
            emit("openTopic", index);
        };

        const trackAccordionEvent = (topic: IPortalTopic, isActive: boolean) => {
            if (typeof window !== "undefined" && (window as any).dataLayer) {
                (window as any).dataLayer.push({
                    event: "harmonica_event",
                    interaction_type: isActive ? "close harmonica" : "expand harmonica",
                    click_text: topic.title
                });
            }
        };

        const trackTopicClick = (topic: IPortalTopic) => {
            if (typeof window !== "undefined" && (window as any).dataLayer) {
                const clickUrl = resolveUrl(topic.url);

                (window as any).dataLayer.push({
                    event: "harmonica_click",
                    click_text: `${labels.value.visit} ${topic.title}`,
                    click_url: clickUrl,
                    block_title: topic.title
                });
            }
        };

        const trackSubtopicClick = (subTopic: any, topic: IPortalTopic) => {
            if (typeof window !== "undefined" && (window as any).dataLayer) {
                const clickUrl = resolveUrl(topic.url);

                (window as any).dataLayer.push({
                    event: "harmonica_subtopic",
                    click_text: subTopic.title,
                    click_url: clickUrl,
                    block_title: topic.title
                });
            }
        };

        return {
            labels,
            currentlyOpenTopic,
            handleAccordionTitleClick,
            trackTopicClick,
            trackSubtopicClick
        }
    }
})
